export enum CompletionType {
  None = 0,
  Completed = 1,
  Cancelled = 2,
}
